"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastVisitedVehicleIdsReducer = void 0;
const lastVisitedVehicleIds_1 = require("../actions/lastVisitedVehicleIds");
const initState = [];
const MAX_LAST_VISTED = 9;
const lastVisitedVehicleIdsReducer = (vehicleIdsArray = initState, action) => {
    switch (action.type) {
        case lastVisitedVehicleIds_1.SET_LAST_VISITED_VEHICLE_IDS:
            return [...action.payload];
        case lastVisitedVehicleIds_1.ADD_VISITED_VEHICLE_ID:
            const arr = [...vehicleIdsArray];
            const index = vehicleIdsArray.indexOf(action.payload);
            if (index !== -1) {
                arr.splice(index, 1);
            }
            if (arr.length === MAX_LAST_VISTED) {
                arr.splice(0, 1);
            }
            arr.push(action.payload);
            return arr;
        default:
            return vehicleIdsArray;
    }
};
exports.lastVisitedVehicleIdsReducer = lastVisitedVehicleIdsReducer;
//# sourceMappingURL=lastVisitedVehicleIds.reducer.js.map